<template>
  <div class="container-fluid">
    <div class="row">
      <div class="d-none d-md-block col-3 pt-5 register-banner">
        <div class="text-md-center mt-5 text-white" style="font-size: 24px">
          Comienza a <b>practicar</b> tus <b>habilidades</b> en
          <b>matemáticas</b> ahora
        </div>
      </div>


      <div class="col p-4">
        <p class="text-black-50 text-right">
          ¿Ya tienes cuenta?
          <router-link to="/login" class="text-dark">Ingresa</router-link>
        </p>

        <div
          class="text-center py-4"
          style="max-width: 600px; margin: auto"
        >
          <MobiusLogo to="/home" />

          <h1 class="text-dark font-h3 mt-5">Terminos y condiciones y Políticas de privacidad.</h1>

          <div class="d-block text-justify mt-4 mb-3 text-black-50">
            Estos términos y condiciones de privacidad de datos, uso de cookies y spam establecen los lineamientos y prácticas de protección de datos personales, uso de cookies y spam del sitio web de la web <b>Mobius</b> generalmente indicadas por la URL "www.mobius.com" y sus dominios de nivel inferior (el "sitio web" o la ¨página web”).
            Mobius es proyecto web para practicas de habilidad mediante cuestionarios practicos, establecido en Colombia. Para obtener más información sobre Mobius, el sitio web y sus operaciones puede referirse al sitio web donde podrá conocer un poco sobre nosotros.<br/>
            Lea atentamente estos términos y condiciones, ya que le ayudarán a tomar decisiones informadas sobre cómo compartir su información personal con nosotros. Aunque estos términos y condiciones se aplican solo a la información recopilada a través del sitio web, son coherentes con nuestras políticas y prácticas con respecto a la información personal que recibimos. <br/><br/>

            <h6>1. ¿Cuál es la información que recopilamos?</h6>
            Información de Identificación Personal que recibamos, entre otros, mediante los formularios de registro u otros que estén en la página web.<br/>
            Esto incluye información de identificación, información de contacto e información técnico, entre otros datos:
            <ol>
              <li>Nombres y apellidos</li>
              <li>Correo electrónico</li>
              <li>Cuenta de redes sociales</li>
            </ol>

            Datos anónimos relacionados con el comportamiento del usuario durante la visita a la página web, sea a través de cookies, píxeles o tecnologías similares. Entre otros, podríamos recompilar el tiempo de la visita y los contenidos visitados.<br/><br/>
            Datos anónimos relacionados con las herramientas de acceso y su interacción con la página web, tales como dirección IP, características del navegador y dispositivo, preferencias de idioma o URL de referencia y otra información técnica.<br/><br/>

            <h6>2. ¿Cómo usamos esta información?</h6>
            Los datos descritos en el punto anterior se utilizan con objetivos de difusión de nuestras actividades, mediante el analisis y compilación de la información generada dentro del sitio web, concerniente a la practica de topicos y habilidades por medio de preguntas.<br/><br/>

            <h6>3. ¿Su información será compartida con alguien?</h6>
            El equipo de Mobius no venderá, distribuirá ni arrendará esta información a terceros.
            Se podrán generar y compartir reportes o resúmenes a partir de los datos recopilados, entre otros, las páginas más visitadas o el número de registrados a un evento. Al ser resúmenes, estos reportes no pueden utilizarse para rastrear a una persona en particular.<br/><br/>

            <h6>4. ¿Utilizamos cookies y otras tecnologías de seguimiento?</h6>

            Las cookies son pequeños archivos de datos que se envían a su navegador o software relacionado desde un servidor web y se almacenan en su computadora o dispositivo. Las cookies a menudo incluyen un identificador único anónimo y rastrean y almacenan sus preferencias de usuarios mientras usan el sitio web, así como información técnica sobre su uso del sitio web.
            <br/>
            Como se mencionó en el apartado 1 arriba, el sitio web y sus sub sitios recopilan registros anónimos durante las visitas de los usuarios. Esto se puede hacer a través de cookies o tecnologías similares para retener información sobre usted y su uso del sitio web.
            <br/><br/>

            <h6>5. ¿Cómo puede comunicarse con nosotros sobre estos términos y condiciones?</h6>

            Si tiene preguntas o comentarios sobre estos términos y condiciones, puede contactarnos a <b>privacidad@mobius.com</b>, que estaremos felices de responderle.

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import bxEnvelope from "@iconify/icons-bx/bx-envelope";

  import MobiusLogo from "@/components/MobiusLogo.vue";
  export default {
    name: "TermsAndConditions",
    components: { MobiusLogo },
    data() {
      return {
        registerInfo: {
          name: "",
          email: "",
          password: "",
          passwordRepeat: "",
        },
        formErrorMessage: {
          name: null,
          email: null,
          password: null,
          passwordRepeat: null,
          passwordValidation: null
        },
        postRegister: false,
        icons: {
          bxEnvelope,
        },
      };
    },
    methods: {
      facebookLoginV2() {
        window.location.href = import.meta.env.VITE_FACEBOOK_AUTH_URL;
      },
      googleLoginV2() {
        window.location.href = import.meta.env.VITE_GOOGLE_AUTH_URL;
      },
      register() {
        if (this.validateRegisterInfo()) {
          axios
            .post(
              `${import.meta.env.VITE_API_BASE_URL}/auth/signup`, this.registerInfo
            )
            .then((apiResponse) => {
              if (apiResponse.status === 201) {
                this.postRegister = true;
              }
            })
            .catch((error) => {
              error.response.data.name
                ? (this.formErrorMessage.name = error.response.data.name.join(
                " "
                ))
                : null;
              error.response.data.email
                ? (this.formErrorMessage.email = error.response.data.email.join(
                " "
                ))
                : null;
              error.response.data.password
                ? (this.formErrorMessage.password = error.response.data.password.join(
                " "
                ))
                : null;
              error.response.data.passwordRepeat
                ? (this.formErrorMessage.passwordRepeat = error.response.data.passwordRepeat.join(
                " "
                ))
                : null;
            });
        }
      },
      validateRegisterInfo() {
        let errorCount = 0;

        if (!this.registerInfo.name) {
          this.formErrorMessage.name = "Este campo es requerido";
          errorCount++;
        } else {
          this.formErrorMessage.name = null;
        }
        if (!this.registerInfo.email) {
          this.formErrorMessage.email = "Este campo es requerido";
          errorCount++;
        } else {
          this.formErrorMessage.email = null;
        }
        if (!this.registerInfo.password) {
          this.formErrorMessage.password = "Este campo es requerido";
          errorCount++;
        } else {
          this.formErrorMessage.password = null;
        }
        if (!this.registerInfo.passwordRepeat) {
          this.formErrorMessage.passwordRepeat = "Este campo es requerido";
          errorCount++;
        } else {
          this.formErrorMessage.passwordRepeat = null;
        }
        if (this.registerInfo.passwordRepeat && this.registerInfo.password &&
          this.registerInfo.password !== this.registerInfo.passwordRepeat) {
          this.formErrorMessage.passwordValidation = "Las contraseñas no coinciden.";
          errorCount++;
        } else {
          this.formErrorMessage.passwordValidation = null;
        }

        return errorCount === 0;
      },

      goToLogin() {
        // Redirect to login
        this.$router.push("/login");
      },
      mounted() {

      },
    },
  };
</script>

<style scoped>
  .register-banner {
    background-image: url("../assets/images/register-banner.jpg");
    min-height: 100vh;
    background-size: cover;
    background-position: center;
    max-width: 430px;
  }
</style>
